const STORAGE_KEY = "karango.auth.pending-notice";
const MAX_AGE_MS = 30 * 60 * 1000;

export function storePendingAuthNotice(notice) {
  if (typeof window === "undefined" || !notice?.message) return false;

  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...notice, createdAt: Date.now() })
    );
    return true;
  } catch {
    return false;
  }
}

export function consumePendingAuthNotice() {
  if (typeof window === "undefined") return null;

  try {
    const rawValue = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    const notice = rawValue ? JSON.parse(rawValue) : null;

    if (
      !notice?.message ||
      !Number.isFinite(Number(notice.createdAt)) ||
      Date.now() - Number(notice.createdAt) > MAX_AGE_MS
    ) {
      return null;
    }

    const { createdAt, ...safeNotice } = notice;
    return safeNotice;
  } catch {
    return null;
  }
}
